export default "__VITE_ASSET__3c9ece56__"